import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect, useMemo, useRef, useState, } from 'react';
const MultiStepFormContext = createContext(undefined);
// Creating a custom hook to access the context
export function useMultiStepFormContext() {
    const context = useContext(MultiStepFormContext);
    if (!context) {
        throw new Error('useMultiStepFormContext must be used within an useMultiStepFormContextProvider');
    }
    return context;
}
export const MultiStepFormController = ({ children, initialNextStepLocked, initialStep = 0, }) => {
    const numberOfSteps = useRef(0);
    const [currentStep, setCurrentStep] = useState(initialStep);
    const [nextStepLocked, setNextStepLocked] = useState(initialNextStepLocked);
    const nextStep = () => {
        if (currentStep < numberOfSteps.current - 1)
            setCurrentStep((prev) => prev + 1);
    };
    const prevStep = () => {
        if (currentStep > 0)
            setCurrentStep((prev) => prev - 1);
    };
    const contextValue = {
        nextStepLocked,
        setNextStepLocked,
        nextStep,
        prevStep,
        currentStep,
        numberOfSteps,
    };
    return (_jsx(MultiStepFormContext.Provider, { value: contextValue, children: children }));
};
export const MultiStepFormView = ({ children }) => {
    const { numberOfSteps, currentStep } = useMultiStepFormContext();
    // Pre-process children to array
    const childrenArray = useMemo(() => React.Children.toArray(children), [children]);
    useEffect(() => {
        // Update context ref to keep track of length
        numberOfSteps.current = childrenArray.length;
    }, [childrenArray]);
    // Render current child in step
    return _jsx(React.Fragment, { children: childrenArray[currentStep] });
};
